import {Modal} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';

interface Props {
  open: boolean;
  onCancel(): void;
  onConfirm(): void;
}

export function ConfirmLeaveModal({open, onConfirm, onCancel}: Props) {
  const [i18n] = useI18n();
  return (
    <Modal
      title={i18n.translate('LeaveConfirmation.title')}
      open={open}
      secondaryActions={[
        {content: i18n.translate('Common.cancel'), onAction: onCancel},
        {
          content: i18n.translate('LeaveConfirmation.confirmLabel'),
          onAction: onConfirm,
          destructive: true,
        },
      ]}
      onClose={onCancel}
    >
      <Modal.Section>
        {i18n.translate('LeaveConfirmation.content')}
      </Modal.Section>
    </Modal>
  );
}
